module.exports = __webpack_public_path__ + "static/media/dtj-color-mock-3.9534633d.jpg";